import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react"
import React from "react"
import Loader from "../../Components/BifrostPageComponent/Loader/Loader"
import Logo from "./Logo/Logo"
import "./Sidebar.scss"
import SidebarNavPanel from "./SidebarNavPanel/SidebarNavPanel"
import UserInfoPanel from "./UserInfoPanel/UserInfoPanel"

const Sidebar = ({ isLoadingForGetUserInfo }) => {
	const { logout } = useAuth0()

	return (
		<aside id="sidebar" className={"sidebar expanded"}>
			<Logo />
			<SidebarNavPanel logout={logout} />
			<UserInfoPanel isLoadingForGetUserInfo={isLoadingForGetUserInfo} />
		</aside>
	)
}

export default withAuthenticationRequired(Sidebar, {
	onRedirecting: () => <Loader />
})
